import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Container } from '@mui/material';

import { useSelector } from '../store/utils';
import { defaultYAxisDomainEndFrom } from '../utils/statistics';

import { Group } from '../organisms/group';

import { ChartBox, useChartBoxModeSelect } from '../molecules/chart-box';

const Statistics = () => {
  const { filters, ...propsOptions } = useChartBoxModeSelect({
    parent: true,
    variableId: undefined,
  });

  const chartBoxProps = {
    options: propsOptions,
    yAxisDomainEndFrom: defaultYAxisDomainEndFrom,
  } as const;

  const [hpAcond, hpEcoone, hpEnabled, hpNibe] = useSelector(
    ({ variables }) => [
      variables.HP_ACOND,
      variables.HP_ECOONE,
      variables.HP_ENABLED,
      variables.HP_NIBE,
    ]
  );

  return (
    <>
      <Container>{filters}</Container>

      <Group
        layout="list"
        visibility={{ variableId: 'PV_INSTALL' }}
        title={
          <FormattedMessage
            id="statistics.photovoltaics.statistics"
            defaultMessage="Výroba elektrárny"
          />
        }
      >
        <ChartBox variableId="PV_POWER_GRAPH" {...chartBoxProps} />
      </Group>

      <Group
        layout="list"
        visibility={{ variableId: 'PV_BATTERY' }}
        title={
          <FormattedMessage
            id="statistics.battery.statistics"
            defaultMessage="Úroveň nabití baterie"
          />
        }
      >
        <ChartBox variableId="PV_BATTERY_SOC_GRAPH" {...chartBoxProps} />
      </Group>

      <Group
        layout="list"
        visibility={{ variableId: 'HW_INSTALL' }}
        title={
          <FormattedMessage
            id="statistics.boiler.statistics"
            defaultMessage="Ohřev bojleru elektrokotlem"
          />
        }
      >
        <ChartBox variableId="HW_POWER_GRAPH" {...chartBoxProps} />
      </Group>

      <Group
        layout="list"
        visibility={{ variableId: 'HP_ENABLED' }}
        title={
          <FormattedMessage
            id="statistics.heatpump.statistics"
            defaultMessage="Spotřeba kompresoru"
          />
        }
      >
        <ChartBox variableId="HP_CONSUMED_GRAPH" {...chartBoxProps} />
      </Group>

      <Group
        layout="list"
        visibility={{ variableId: 'PV_INSTALL' }}
        title={
          <FormattedMessage
            id="statistics.electrical_grid.statistics"
            defaultMessage="Nákup z distribuční sítě"
          />
        }
      >
        <ChartBox variableId="EM_CONSUMED_GRAPH" {...chartBoxProps} />
      </Group>

      <Group
        layout="list"
        visibility={{ variableId: 'PV_INSTALL' }}
        title={
          <FormattedMessage
            id="statistics.electrical_grid.statistics_overflow"
            defaultMessage="Přetok do distribuční sítě"
          />
        }
      >
        <ChartBox variableId="EM_OVERFLOW_GRAPH" {...chartBoxProps} />
      </Group>

      <Group
        layout="list"
        visibility={{
          variableIds: ['EM_INSTALL', 'DEV_HOME_CONSUMPTION_GRAPH'],
        }}
        title={
          <FormattedMessage
            id="statistics.electrical_grid.statistics_house_consumption"
            defaultMessage="Spotřeba objektu"
          />
        }
      >
        <ChartBox variableId="HOME_CONSUMPTION" {...chartBoxProps} />
      </Group>

      <Group
        layout="list"
        visibility={{ variableId: 'PL_INSTALL' }}
        title={
          <FormattedMessage
            id="statistics.plug.statistics"
            defaultMessage="Spotřeba zásuvky"
          />
        }
      >
        <ChartBox variableId="PL_POWER_GRAPH" {...chartBoxProps} />
      </Group>

      <Group
        layout="list"
        visibility={{ variableId: 'WIND_INSTALL' }}
        title={
          <FormattedMessage
            id="statistics.wind.statistics"
            defaultMessage="Výroba větrné elektrárny"
          />
        }
      >
        <ChartBox variableId="WIND_POWER_GRAPH" {...chartBoxProps} />
      </Group>

      {Boolean(hpEnabled && (hpAcond || hpEcoone || hpNibe)) && (
        <Group
          layout="list"
          title={
            <FormattedMessage
              id="statistics.outdoor_temperature.statistics"
              defaultMessage="Venkovní teplota"
            />
          }
        >
          <ChartBox variableId="OUTDOOR_TEMP_GRAPH" {...chartBoxProps} />
        </Group>
      )}
    </>
  );
};

export default Statistics;
